import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanDeactivate,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { SecretService } from '../services/secret.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private commonRoutes: string[] = [
    '/users/role',
    '/users/privileges',
    '/settings/global-settings',
    '/settings/client-contract',
    '/emailsettings/setEmailSetting',
    '/settings/help-me',
    '/my-profile',
    '/my-profile?activeIndex=1',
    '/users/edit',
    '/onboard-clients/edit',
    '/leads/view-lead',
    '/deals/edit',
    '/companies/view-company',
    '/leads/edit',
    'course/create',
    '/learner/edit',
    '/dashboard/course-preview-single-colume',
    '/dashboard/course-preview-double-colume',
    '/dashboard/archived-courses',
    '/double-layout-learner',
    '/single-layout-learner',
    '/certificate',
    '/reward',
    '/vacancy',

    '/customer/view-single-customer',
    '/promotion/banner/create',
    '/promotion/banner/edit',
    '/promotion/top-picture/create',
    '/promotion/top-picture/edit',
    '/settings/business-list',
    '/settings/business-config',
    '/bussiness-list',
  ];

  private sharedRoutes: string[] = ['/machine/view/*'];
  protectCreateSite: any = JSON.parse(sessionStorage.getItem('protectCreateSite') as string);
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private secretService: SecretService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = localStorage.getItem('token');
    // console.log("Token :", token);
    let role = this.secretService.decryptLocalStorageData(localStorage.getItem('role'))
      ? this.secretService.decryptLocalStorageData(localStorage.getItem('role'))?.toLowerCase()
      : null;
    let role_number = this.secretService.decryptLocalStorageData(
      localStorage.getItem('role_number')
    )
      ? parseInt(
          this.secretService.decryptLocalStorageData(localStorage.getItem('role_number')) as string
        )
      : null;
    let role_type = this.secretService.decryptLocalStorageData(localStorage.getItem('role_type'))
      ? parseInt(
          this.secretService.decryptLocalStorageData(localStorage.getItem('role_type')) as string
        )
      : null;
    // console.log('Loggedin User: ', role, role_number);
    let urlSlug: any;
    console.log('role_number : ', role_number);
    switch (role_number) {
      case 1:
        urlSlug = 'admin';
        break;
      case 2:
        urlSlug = 'admin';
        break;
      // case 3:
      //   urlSlug = 'account-manager';
      //   break;
      case 4:
        urlSlug = 'learner';
        break;
        // case 5:
        //   urlSlug = 'service-engineer';
        break;
      default:
        // if (role_type === 1) {
        //   urlSlug = 'admin';
        // } else if (role_type === 2) {
        //   urlSlug = 'account-manager';
        // }
        urlSlug = 'admin';
        break;
    }
    // console.log('role : ', role);
    // console.log('urlSlug : ', urlSlug);
    const routerState = state;
    // console.log(JSON.parse(localStorage.getItem('permittedRoutes') as string));
    if (token) {
      // Check common routes first
      const urlWithoutPrefix = routerState.url.replace(/^\/[^/]+/, '');
      if (this.isRoutePermitted(urlWithoutPrefix, this.commonRoutes)) {
        return true;
      }
      
      if (routerState.url.search(urlSlug) > -1) {
        return this.checkAuthorizedRoutes(routerState.url, urlSlug);
        // return true;
      } else if (routerState.url.search('common') > -1) {
        return true;
      } else {
        // location.href = '/';
        // console.log('routerState>> ', routerState.url);
        if (role_number == 5 || role_number == 7) {
          this.router.navigate(['/client-login']).then(() => {
            // console.log('Babai');
            this.toastr.warning('Unauthorised Access!');
          });
        } else {
          if (routerState.url.search('client') > -1) {
            this.router.navigate(['/client-login']).then(() => {
              // console.log(333);
              this.toastr.warning('Unauthorised Access!');
            });
          } else {
            if (routerState.url.search('hospitality') > -1) {
              this.router.navigate(['/hospitality-login']).then(() => {
                // console.log(444);
                this.toastr.warning('Unauthorised Access!');
              });
            } else {
              this.router.navigate(['']).then(() => {
                // console.log('Gerrard');
                this.toastr.warning('Unauthorised Access!');
              });
            }
          }
        }
        return false;
      }
    } else {
      localStorage.clear();
      // let currentPath = routerState.url;
      // console.log('>>>', currentPath);
      if (routerState.url.search('client') > -1) {
        this.router.navigate(['/client-login']).then(() => {
          console.log(333);
          this.toastr.warning('Unauthorised Access. Please login first!');
        });
      } else {
        this.router
          .navigate(['/'], {
            queryParams: {
              ref: routerState.url,
            },
          })
          .then(() => {
            console.log(222);
            this.toastr.warning('Unauthorised Access. Please login first!');
          });
      }
      return false;
    }
  }

  checkAuthorizedRoutes(url: string, urlSlug: string): boolean {
    const permittedRoutesJSON = localStorage.getItem('permittedRoutesCCSCRM');

    if (!permittedRoutesJSON || permittedRoutesJSON === 'undefined') {
      this.toastr.warning('Could not authorize! Contact Admin.');
      return false;
    }

    // Parse permitted routes from JSON string
    const permittedRoutes: string[] = JSON.parse(permittedRoutesJSON);

    // Remove the initial slug from the URL to get the target URL
    const urlWithoutSlug = url.slice(urlSlug.length + 1);
    // Remove any query parameters from the target URL
    const targetUrl = urlWithoutSlug.split('?')[0];

    // Check if the target URL is authorized
    const isAuthorized =
      this.isRoutePermitted(targetUrl, permittedRoutes) ||
      this.isRoutePermitted(targetUrl, this.commonRoutes) ||
      this.isRoutePermitted(targetUrl, this.sharedRoutes);

    // If not authorized, show a warning message
    if (!isAuthorized) {
      this.toastr.warning('You are not authorized!');
    }

    // Return the authorization status
    return isAuthorized;
  }

  isRoutePermitted(url: string, routes: string[]): boolean {
    // Check if any route matches the target URL
    const permitted = routes.some(route => this.matchRoute(url, route));
    // console.log('Permitted : ', permitted, url, routes);
    return permitted;
  }

  matchRoute(url: string, route: string): boolean {
    // Split the URL and the route pattern into segments
    const urlSegments = url.split('/');
    const routeSegments = route.split('/');

    // If the number of segments does not match, the route does not match
    if (urlSegments.length !== routeSegments.length) {
      return false;
    }

    // Check each segment for a match, allowing wildcards ('*')
    return routeSegments.every(
      (segment, index) => segment === '*' || segment === urlSegments[index]
    );
  }
}
